<template>
  <div class="search-wrapper input-group col-10" ref="search_wrapper">
    <!-- Loader -->
    <preloader v-if="loading"></preloader>
    <!-- Табы -->
    <div class="row justify-center mb-9">
      <div class="col-7 search-tab d-flex justify-space-between">
        <ul class="search-tab_list d-flex">
          <li
            @click="activeTab = 1"
            class="search-tab_link mr-10"
            :class="{'search-tab_link--active': activeTab === 1}"
          >{{ $t('Все') }}</li>
          <li
            @click="activeTab = 2"
            class="search-tab_link mr-10"
            :class="{'search-tab_link--active': activeTab === 2}"
          >{{ $t('Продукты') }}</li>
          <!-- modelList.length !== 0 ? activeTab = 2 : ''
          'search-tab_link--disabled': modelList.length === 0-->
          <li
            @click="activeTab = 3"
            class="search-tab_link mr-10"
            :class="{'search-tab_link--active': activeTab === 3}"
          >{{$t('Производители')}}</li>
          <!-- 'search-tab_link--disabled': manSort.length === 0 -->
          <li
            @click="activeTab = 4"
            class="search-tab_link mr-10"
            :class="{'search-tab_link--active': activeTab === 4}"
          >{{$t('Статьи')}}</li>
          <!-- 'search-tab_link--disabled': articlesFiltredList.length === 0 -->
        </ul>
        <a
          href="javascript:void(0);"
          @click="showModal = 'addsearch'"
          class="search-tab_link fz15 fw-normal"
        >{{$t('Не нашли то, что искали?')}}</a>
      </div>
    </div>

    <!-- Модалка -->
    <addsearch v-if="showModal === 'addsearch'" @close="showModal = 'closed'"></addsearch>

    <!-- Инпут -->
    <div class="row justify-center posr mb-12">
      <div class="search-input_block d-flex posr col-7 px-0">
        <input
          class="search-global form-control standart-input input"
          type="text"
          id="inputMegaSearch"
          v-model="searchGlobal"
          ref="inputSearch"
          @keydown.down.prevent="highlightedNext"
          @keydown.up.prevent="highlightedPrev"
          @keydown.enter.prevent="enterListItem()"
          @keydown.escape.prevent="closed = true"
          @blur="closed = true"
          @focus="openSearchList"
          :placeholder="$t(placeholder)"
          :class="{'search--border': searchGlobal !== ''}"
          autocomplete="off"
        />
        <!-- @keydown.exact="resetPositionSelect($event)" -->
        <div class="search_btn">
          <i @click="enterListItem(0)" class="icon-arrow-right active-color fz20"></i>
        </div>
      </div>

      <transition name="slideup-fade" mode="out-in">
        <transition-group
          v-show="!closed"
          name="slide-fade"
          tag="ul"
          class="search-list col-7 px-0"
          id="list_block"
          ref="searchModelList"
        >
          <!-- <li key="search_typed" ref="srch" class="list_item">
            <a :href="'/models?name='+searchGlobal" target="_blank">
              <i class="icon-search icon_search"></i>
              {{searchGlobal}}
            </a>
          </li>-->
          <!-- <li
            v-for="(orgName, i) of filteredDataOrg"
            :key="orgName.id"
            class="list_item"
            ref="findCategory"
            :class="{'active-list_item': i === highlightedIndex}"
          >
            <a
              :href="`/manufacturer/${orgName.name_short.toLowerCase()}/${orgName.id}/`"
              target="_blank"
              @click="getCompanyData(orgName.id)"
            >
              <i class="icon-company icon_search"></i>
              {{orgName.name_short}}
              <span class="category-search">Производители</span>
            </a>
          </li>-->

            <!-- ref="findCategory" -->
          <li
            v-for="(className, i) of filteredResult"
            :key="className.type === 'model' ? className.code : className.id+i"
            class="list_item"
            :class="{'active-list_item': i === highlightedIndex}"
          >
            <a
              href="javascript:void(0);"
              @click="enterListItem(0)"
              v-if="className.type === 'search'"
            >
              <i class="icon-search icon_search"></i>
              {{searchGlobal}}
            </a>
            <a
              v-else
              :href="className.type === 'model' ? `/models?class=${className.code}` : `/manufacturer/id/${className.id}/`"
              target="_blank"
            >
              <i v-if="className.type === 'model'" class="icon-grid icon_search"></i>
              <i v-else class="icon-company icon_search"></i>
              {{className.type === 'model' ? className.name : className.meta_alias}}
              <span
                class="category-search"
              >{{className.type === 'model' ? $t('Модели') : 'Производители'}}</span>
            </a>
          </li>
        </transition-group>
      </transition>
    </div>

    <!-- Теги (сейчас отключены) -->
    <div
      class="search-tag-wrapper d-flex col-9 mx-auto flex-wrap justify-center"
      v-if="false"
    >
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Архитектурные объекты</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <img src="/dist/assets/front_white/img/man_bg.jpg" alt />
        <p class="tag-text">BuildingSmart</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Производители</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Электроснабжение</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Новости</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <img src="/dist/assets/front_white/img/man_bg.jpg" alt />
        <p class="tag-text">Miele</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Вакансии</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Холодильник Miele</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <img src="/dist/assets/front_white/img/man_bg.jpg" alt />
        <p class="tag-text">Плагины для CAD</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Производители</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Архитектурные объекты</p>
      </a>
      <a href="javascript:void(0);" class="tag-block">
        <p class="tag-text">Электроснабжение</p>
      </a>
    </div>

    <!-- Результаты поиска "Все" -->
    <div class="search-result row justify-center" v-if="activeTab===1 && !checkNotFound">
      <!-- Модели -->
      <div v-if="modelList.length >= 1" class="result_block col-8">
        <h3 class="h3 text-left mb-10">{{ $t('Продуктов') }} ({{ numberWithSpaces(totalmodels) }})</h3>
        <div
          class="models-grid mb-10"
          :class="{show: show.models === true}"
        >
          <bim-product-card width="100%" v-for="model in modelList" :key="model.id" v-bind="formModelData(model)" target="_blank" />
        </div>

        <v-btn
          color="green"
          class="d-block mx-auto mb-10"
          outline
          big
          width="20.6667rem"
          height="3.2rem"
          v-if="totalmodels > 30"
          @click="activeTab=2"
        >Показать ещё продукты ({{totalmodels-30}})</v-btn>

        <!-- TODO: скрывать если кол-во результатов вмещается в блок -->
        <!-- <div
          v-if="checkAmountElements(modelList)"
          class="d-flex show-more justify-center mb-12"
        >
          <a
            href="javascript:void(0);"
            class="show-more_link px-md-6"
            @click="show.models = !show.models"
          >
            <i :class="{rotate: show.models === true}" class="icon-input-droplist"></i>
            {{show.models ? 'Свернуть' : 'Показать больше'}}
            <i
              :class="{rotate: show.models === true}"
              class="icon-input-droplist"
            ></i>
          </a>
        </div> -->
      </div>

      <!-- Производители -->
      <div v-if="sortByVip.length >= 1" class="result_block col-8">
        <h3
          class="h3 text-center mb-10"
        >{{ $t('Производителей') }} ({{ numberWithSpaces(sortByVip.length) }})</h3>
        <div
          class="manufacturers d-flex flex-wrap justify-center mb-10"
          :class="{show: show.manufacturers === true}"
        >
          <!-- TODO: Ограничить количество выводимых результатов в зависимости от ширины экрана -->
          <a
            :href="`/manufacturer/${man.name_alias}/${man.id}/`"
            class="manufacturer-card d-flex flex-column align-center justify-center mr-6 mb-6"
            :class="man.vip_status === 'vip' ? 'manufacturer-card--vip' : 'manufacturer-card'"
            v-for="(man, index) in sortByVip"
            :key="man.id"
            v-if="index < 30"
            target="_blank"
          >
            <div class="manufacturer-logo d-flex align-center justify-center">
              <img
                :src="man.logo.link"
                :alt="man.name_alias"
                class="mw-100"
                v-if="man.logo.link !=='' && man.logo.link !== null && man.logo.link !== undefined"
              />
              <img class="mw-100" src="/dist/assets/front_white/img/svg/no-logo.svg" v-else alt="no logo" />
            </div>
            <div class="manufacturer-info d-flex flex-column justify-center">
              <h5 class="h5 nowrap manufacturer-name">{{man.name_short}}</h5>
              <!-- <div class="manufacturer-counters d-flex justify-start">
                <i class="icon-vip" v-if="man.vip_status === 'vip'"></i>
                <i class="icon-medal" v-if="man.top_status !== 'empty'"></i>
                <div class="models-counter fontM">
                  <i class="icon-mark-models"></i>
                  {{ numberWithSpaces(man.model_count) }}
                </div>
              </div>-->
            </div>
          </a>
        </div>

        <v-btn
          color="green"
          class="d-block mx-auto mb-10"
          outline
          big
          width="20.6667rem"
          height="3.2rem"
          v-if="sortByVip.length > 30"
          @click="activeTab=3"
        >Показать ещё производителей ({{sortByVip.length-30}})</v-btn>

        <!-- TODO: скрывать если кол-во результатов вмещается в блок -->
        <!-- <div
          v-if="checkAmountElements(sortByVip)"
          class="d-flex show-more justify-center mb-12"
        >
          <a
            href="javascript:void(0);"
            class="show-more_link px-md-6"
            @click="show.manufacturers = !show.manufacturers"
          >
            <i :class="{rotate: show.manufacturers === true}" class="icon-input-droplist"></i>
            {{show.manufacturers ? 'Свернуть' : 'Показать больше'}}
            <i
              :class="{rotate: show.manufacturers === true}"
              class="icon-input-droplist"
            ></i>
          </a>
        </div> -->
      </div>

      <!-- Статьи -->
      <div v-if="articlesFiltredList.length >= 1" class="result_block col-8">
        <h3
          class="h3 text-center mb-10"
        >{{ $t('Статей') }} ({{ numberWithSpaces(articlesFiltredList.length) }})</h3>
        <div
          class="news d-flex flex-wrap justify-center mb-10"
          :class="{show: show.articles === true}"
        >
          <!-- TODO: Ограничить количество выводимых результатов в зависимости от ширины экрана -->
          <a
            :href="`/articles/${news.meta_alias}`"
            class="news-card d-flex flex-column align-start mr-6 mb-6"
            v-for="(news, index) in articlesFiltredList"
            :key="news.id"
            v-if="index < 30"
            target="_blank"
          >
            <img
              v-if="news.img360x200 !=='' && news.img360x200 !== null && news.img360x200 !== undefined"
              :src="news.img360x200"
              :alt="news.meta_alias"
              class="news_img"
            />
            <div v-else class="no-image news_img">
              <img src="/dist/assets/front_white/img/svg/no-pic-big.svg" alt="no image" />
            </div>

            <div class="news_block">
              <h5 class="news_header">{{sliceText(news.title, 50)}}</h5>
              <p class="news_text">{{news.short}}</p>
            </div>
            <div class="news_footer">
              <div class="news_counter-block fontM d-flex">
                <span class="d-flex align-center">
                  <i class="icon-pass-visible-y"></i>
                  {{news.views}}
                </span>
                <!-- <span class="d-flex align-center">
                  <i class="icon-mark-comments"></i>
                  {{news.comments}}
                </span>-->
              </div>
              <span class="uppercase news_read-more">читать полностью</span>
            </div>
          </a>
        </div>

        <v-btn
          color="green"
          class="d-block mx-auto mb-10"
          outline
          big
          width="20.6667rem"
          height="3.2rem"
          v-if="articlesFiltredList.length > 30"
          @click="activeTab=4"
        >Показать ещё новостей ({{articlesFiltredList.length-30}})</v-btn>

        <!-- <div
          v-if="checkAmountElements(articlesFiltredList)"
          class="d-flex show-more justify-center mb-12"
        >
          <a
            href="javascript:void(0);"
            class="show-more_link px-md-6"
            @click="show.articles = !show.articles"
          >
            <i :class="{rotate: show.articles === true}" class="icon-input-droplist"></i>
            {{show.articles ? 'Свернуть' : 'Показать больше'}}
            <i
              :class="{rotate: show.articles === true}"
              class="icon-input-droplist"
            ></i>
          </a>
        </div> -->
      </div>
    </div>

    <!-- Результаты "Модели" -->
    <div class="search-result_models row justify-center" v-show="activeTab === 2 && !checkNotFound">
      <div class="result_block col-8">
        <h3
          v-if="totalmodels !== 0"
          class="h3 text-left mb-10"
        >{{ $t('Продуктов') }} ({{ numberWithSpaces(totalmodels) }})</h3>

        <!-- Ничего не найдено -->

        <div
          v-if="notFound === true && totalmodels === 0 && !checkNotFound"
          class="d-flex flex-column align-center not-found"
        >
          <p class="h1 text-center soft_light-color mb-10">{{$t('Ничего не найдено')}}</p>
          <v-btn
            color="green"
            outline
            big
            width_btn="267px"
            height_btn="48px"
            @click="showModal = 'addsearch'"
            class="fz18"
          >Не нашли то, что искали?</v-btn>
        </div>
        <!-- <a
          href="javascript:void(0);"
          :class="{activeInf: infinity===true}"
          class="mb-11 d-block mx-auto text-center"
          @click="infinity = !infinity"
        >
          <i class="icon-infinity-normal"></i>
        </a>-->
        <!-- TODO: сделать функцию добавления результатов -->

        <!-- v-infinite-scroll="loadMore"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
        infinite-scroll-immediate-check="false"-->
        <div class="models-grid mb-10">
          <bim-product-card width="100%" v-for="model in modelList" :key="model.id" v-bind="formModelData(model)" target="_blank" />
        </div>
        <pagination
          v-if="showPaginationModels"
          :currentPage="1"
          :length="20"
          :arr="modelList"
          @params="modelPagination"
          :pageTotal="totalmodelsPages"
          multi
          parentClass="mega_search"
        />
      </div>
    </div>

    <!-- Результаты "Производители" -->
    <div class="search-result_models row justify-center" v-show="activeTab === 3 && !checkNotFound">
      <div class="result_block col-8">
        <h3
          v-if="sortByVip.length !== 0"
          class="h3 text-center mb-10"
        >{{ $t('Производителей') }} ({{ numberWithSpaces(sortByVip.length) }})</h3>

        <!-- Ничего не найдено -->

        <div
          v-if="notFound === true && sortByVip.length === 0 && !checkNotFound"
          class="d-flex flex-column align-center not-found"
        >
          <p class="h1 text-center soft_light-color mb-10">{{$t('Ничего не найдено')}}</p>
          <v-btn
            color="green"
            outline
            big
            width_btn="267px"
            height_btn="48px"
            @click="showModal = 'addsearch'"
            class="fz18"
          >Не нашли то, что искали?</v-btn>
        </div>
        <!-- <a
          href="javascript:void(0);"
          :class="{activeInf: infinity===true}"
          class="mb-11 d-block mx-auto text-center"
          @click="infinity = !infinity"
        >
          <i class="icon-infinity-normal"></i>
        </a>-->

        <div
          class="manufacturers show d-flex flex-wrap justify-center mb-10"
          :class="{show: show.manufacturers === true}"
        >
          <a
            :href="`/manufacturer/${man.name_alias}/${man.id}/`"
            class="manufacturer-card d-flex flex-column align-center justify-center mr-6 mb-6"
            :class="man.vip_status === 'vip' ? 'manufacturer-card--vip' : 'manufacturer-card'"
            v-for="man in manSort"
            :key="man.id"
            target="_blank"
          >
            <div class="manufacturer-logo d-flex align-center justify-center">
              <img
                :src="man.logo.link"
                :alt="man.name_alias"
                class="mw-100"
                v-if="man.logo.link !=='' && man.logo.link !== null && man.logo.link !== undefined"
              />
              <img class="mw-100" src="/dist/assets/front_white/img/svg/no-logo.svg" v-else alt="no logo" />
            </div>
            <div class="manufacturer-info d-flex flex-column justify-center">
              <h5 class="h5 nowrap manufacturer-name">{{man.name_short}}</h5>
              <!-- <div class="manufacturer-counters d-flex justify-start">
                <i class="icon-vip" v-if="man.vip_status === 'vip'"></i>
                <i class="icon-medal" v-if="man.top_status !== 'empty'"></i>
                <div class="models-counter fontM">
                  <i class="icon-mark-models"></i>
                  {{ numberWithSpaces(man.model_count) }}
                </div>
              </div>-->
            </div>
          </a>
        </div>
        <pagination
          :currentPage="1"
          :length="20"
          :arr="sortByVip"
          @params="manufacturersPagination"
          multi
          parentClass="mega_search"
        />
      </div>
    </div>

    <!-- Результаты "Статьи" -->
    <div class="search-result_models row justify-center" v-show="activeTab === 4 && !checkNotFound">
      <div class="result_block col-8">
        <h3
          v-if="articlesFiltredList.length !== 0"
          class="h3 text-center mb-10"
        >{{ $t('Статей') }} ({{ numberWithSpaces(articlesFiltredList.length) }})</h3>

        <!-- Ничего не найдено -->

        <div
          v-if="notFound === true && articlesFiltredList.length === 0 && !checkNotFound"
          class="d-flex flex-column align-center not-found"
        >
          <p class="h1 text-center soft_light-color mb-10">{{$t('Ничего не найдено')}}</p>
          <v-btn
            color="green"
            outline
            big
            width_btn="267px"
            height_btn="48px"
            @click="showModal = 'addsearch'"
            class="fz18"
          >Не нашли то, что искали?</v-btn>
        </div>
        <!-- <a
          href="javascript:void(0);"
          :class="{activeInf: infinity===true}"
          class="mb-11 d-block mx-auto text-center"
          @click="infinity = !infinity"
        >
          <i class="icon-infinity-normal"></i>
        </a>-->

        <div
          class="news show d-flex flex-wrap justify-center mb-10"
          :class="{show: show.articles === true}"
        >
          <a
            :href="`/articles/${news.meta_alias}-${news.id}`"
            class="news-card d-flex flex-column align-start mr-6 mb-6"
            v-for="news in artSort"
            :key="news.id"
            target="_blank"
          >
            <img
              v-if="news.img360x200 !=='' && news.img360x200 !== null && news.img360x200 !== undefined"
              :src="news.img360x200"
              :alt="news.meta_alias"
              class="news_img"
            />
            <div v-else class="no-image news_img">
              <img src="/dist/assets/front_white/img/svg/no-pic-big.svg" alt="no image" />
            </div>

            <div class="news_block">
              <h5 class="news_header">{{sliceText(news.title, 50)}}</h5>
              <p class="news_text">{{news.short}}</p>
            </div>
            <div class="news_footer">
              <div class="news_counter-block fontM d-flex">
                <span class="d-flex align-center">
                  <i class="icon-pass-visible-y"></i>
                  {{news.views}}
                </span>
                <!-- <span class="d-flex align-center">
                  <i class="icon-mark-comments"></i>
                  {{news.comments}}
                </span>-->
              </div>
              <span class="uppercase news_read-more">читать полностью</span>
            </div>
          </a>
        </div>
        <pagination
          :currentPage="1"
          :length="15"
          :arr="articlesFiltredList"
          @params="artPagination"
          multi
          parentClass="mega_search"
        />
      </div>
    </div>

    <!-- Ничего не найдено -->
    <div
      v-if="notFound === true
      && searchGlobal.length > 0
      && checkNotFound"
      class="d-flex flex-column align-center not-found"
    >
      <p class="h1 text-center soft_light-color mb-10">{{$t('Ничего не найдено')}}</p>
      <v-btn
        color="green"
        outline
        big
        width_btn="267px"
        height_btn="48px"
        @click="showModal = 'addsearch'"
        class="fz18"
      >Не нашли то, что искали?</v-btn>
    </div>
  </div>
</template>

<script>
/*
При открытии окна счётчик равен 0, когда появляется список счётчик равен 0 (counter = 0)
при нажатии на ESC и открытом списке счётчик становится 1 и список закрывается. Через 10 сек. снова становится равен 0.
При нажатии на ESC если список закрыт окно закрывается (counter = 0)
*/
import modal from '../Modal.vue'
import addsearch from '../../components/main-page/NotFoundModal.vue'
// import addsearch from './AddSearchModal.vue'
import FormModelCardDataMixin from '@/mixins/models/form-model-card-data'
import bimProductCard from '@bimlib/components/bimProductCard'
// import pagination from "../pagination.vue";

export default {
  mixins: [FormModelCardDataMixin],
  components: { modal, addsearch, bimProductCard },
  props: {
    placeholder: {
      type: String,
      default: "Поиск"
    }
  },
  data() {
    return {
      showPaginationModels: true,
      notFound: false,
      loading: false,
      showModal: "closed",
      infinity: true,
      searchGlobal: "",
      searchResult: [],
      getClass: [],
      sortByVip: [],
      closed: true,
      filteredArray: [],
      activeTab: 1,
      highlightedIndex: 0,
      show: {
        models: false,
        manufacturers: false,
        articles: false
      },
      modelList: [],
      totalmodels: 0,
      totalmodelsPages: 0,
      page_models: 1,
      manufacturerList: [],
      articlesList: [],
      articlesFiltredList: [],
      paramsArt: {},
      paramsMan: {},
      params: {},
      dropdownLists: {
        models: [],
        manufacturers: []
      }
    };
  },
  created() {
    this.getData();
    this.numberWithSpaces();
  },
  watch: {
    searchGlobal() {
      this.highlightedIndex = 0;
      if (this.searchGlobal.length >= 2 && !_.isEmpty(this.filteredResult)) {
        this.closed = false
      } else {
        this.closed = true
        this.$refs.searchModelList.$el.scrollTo(0, 0)
      }
    },
    filteredArray: "pushFilteredDataInArray"
  },
  computed: {
    checkNotFound () {
      if (this.filteredResult.length === 1 // 1 т.к. там добавлен объект с поиском
      && this.articlesFiltredList.length === 0
      && this.totalmodels === 0
      && this.manufacturerList.length === 0) {
        return true
      }
    },
    /**
     * Фильтруем массив с полученными классами моделей и производителями
     */
    filteredResult() {
      const dropdownList = [...this.searchResult]
      if (this.activeTab === 1) {
        dropdownList.push(...[...this.dropdownLists.models, ...this.dropdownLists.manufacturers])
      } else if (this.activeTab === 2) {
        dropdownList.push(...this.dropdownLists.models)
      } else if (this.activeTab === 3) {
        dropdownList.push(...this.dropdownLists.manufacturers)
      }
      return dropdownList.filter(post => {
        if (post.type !== 'search') {
          return (
            post.name.toLowerCase().includes(this.searchGlobal.toLowerCase()) ||
            post.meta_alias
              .toLowerCase()
              .includes(this.searchGlobal.toLowerCase())
          );
        } else return post
      });
    },
    manSort() {
      return this.sortByVip.filter((row, index) => {
        let start = (this.paramsMan.currentPage - 1) * this.paramsMan.length;
        let end = this.paramsMan.currentPage * this.paramsMan.length;
        if (index >= start && index < end) return true;
      });
    },
    artSort() {
      return this.articlesFiltredList.filter((row, index) => {
        let start = (this.paramsArt.currentPage - 1) * this.paramsArt.length;
        let end = this.paramsArt.currentPage * this.paramsArt.length;
        if (index >= start && index < end) return true;
      });
    }
  },

  methods: {
    /**
     * Вычисление ширины окна
     */
    calcWindowWidth() {
      return document.body.clientWidth;
    },
    /**
     * Проверка количества выводимых результатов
     * Используется для v-if которое контролирует поведение кнопки "Показать еще"
     */
    checkAmountElements(arr) {
      const windowWidth = this.calcWindowWidth();
      let show;
      if (windowWidth <= 1425 && arr.length > 4) {
        show = true;
      } else if (windowWidth > 1425 && windowWidth <= 1706 && arr.length > 5) {
        show = true;
      } else if (windowWidth > 1706 && windowWidth <= 1989 && arr.length > 6) {
        show = true;
      } else show = windowWidth >= 1900 && arr.length > 7;

      return show;
    },
    /**
     * Скроллит выпадающий список при управлении стрелками
     */
    scrollToHighligted() {
      this.$refs.searchModelList.children[
        this.highlightedIndex
      ].elm.scrollIntoView({
        block: "nearest"
      });
      // this.$refs.searchModelList.children[this.highlightedIndex].elm.classList.add('active-list_item')
    },
    /**
     * счётчик управления подсветкой результатов в выпадашке
     */
    highlight(index) {
      this.highlightedIndex = index;

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredResult.length - 1;
      }
      if (this.highlightedIndex > this.filteredResult.length - 1) {
        this.highlightedIndex = 0;
      }
      this.scrollToHighligted();
    },
    /**
     * Функция для листания стрелкой "вверх"
     */
    highlightedPrev() {
      this.highlight(this.highlightedIndex - 1);
    },
    /**
     * Функция для листания стрелкой "вниз"
     */
    highlightedNext() {
      this.highlight(this.highlightedIndex + 1);
    },
    /**
     * Функция прокрутки страницы вверх при клике на пагинацию
     */
    // scrollingToTop() {
    //   this.$refs.search_wrapper.scrollIntoView({
    //     top: 0,
    //     behavior: "smooth"
    //   });
    // },
    modelPagination(data) {
      this.params = data;
      this.page_models = this.params.currentPage;
      if (this.activeTab === 2) {
        this.getRenderData();
        // this.scrollingToTop();
      }
    },
    manufacturersPagination(data) {
      this.paramsMan = data;
      if (this.activeTab === 3) {
        // this.scrollingToTop();
      }
    },
    artPagination(data) {
      this.paramsArt = data;
      // if (this.activeTab === 4) {
      //   this.scrollingToTop();
      // }
    },
    changePage: function(item) {
      if (this.page_models === item) {
      } else {
        this.page_models = item;
        this.getRenderData();
      }
    },
    loadMore: function() {
      this.busy = true;

      setTimeout(() => {
        if (this.modelList.length >= 30) {
          this.getRenderData("add_30_models");
          this.busy = false;
        }
      }, 600);
    },
    /**
     * Ф-ия разделения чисел на разряды
     */
    numberWithSpaces(x) {
      return _.toString(x).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    openSearchList() {
      if (this.searchGlobal.length >= 2 && !_.isEmpty(this.filteredResult)) {
        this.closed = false;
      } else return (this.closed = true);
    },
    /**
     * Получение параметров из GET и добавление в INPUT
     */
    // getUrlParams() {
    //   var url_params = new URLSearchParams();
    //   if (window.location.toString().indexOf("?") != -1) {
    //     var href_part = window.location.search.split("?")[1];
    //     href_part.replace(/([^=&]+)=([^&]*)/g, function(m, key, value) {
    //       var attr = decodeURIComponent(key);
    //       var val = decodeURIComponent(value);
    //       url_params.append(attr, val);
    //     });
    //   }
    //   for (var pair of url_params.entries()) {
    //     // console.log(pair[0]+ '->'+ pair[1]);
    //     if (pair[1] != []) {
    //       this.searchGlobal = pair[1];
    //     }
    //   }
    //   // console.log(url_params);
    //   return url_params;
    // },

    /**
     * Сортировка статей
     */
    articlesSort() {
      this.articlesFiltredList = this.articlesList.filter(item => {
        return (
          _.lowerCase(item.title).includes(_.lowerCase(this.searchGlobal)) ||
          _.lowerCase(item.short).includes(_.lowerCase(this.searchGlobal)) ||
          _.lowerCase(item.meta_alias).includes(_.lowerCase(this.searchGlobal))
        );
      });
    },

    /**
     * Сортировка производителей по VIP
     */
    sortingVip() {
      let vip = this.sortByVip;
      vip = _.sortBy(vip, ["vip_status"]).reverse();

      this.sortByVip = vip.filter(post => {
        return (
          post.name_short
            .toLowerCase()
            .includes(this.searchGlobal.toLowerCase()) ||
          post.name_alias
            .toLowerCase()
            .includes(this.searchGlobal.toLowerCase()) ||
          post.name_full
            .toLowerCase()
            .includes(this.searchGlobal.toLowerCase())
        );
      });
    },
    /**
     * Получаем модели для отрисовки
     */
    getDataModels(val) {
      this.loading = true;
      let man = false;

      const data = new URLSearchParams();
      data.append("limit", 30);
      data.append("sort", "random");
      if (this.page_models) {
        data.append("page", this.page_models);
      }
      if (!man) {
        data.append("name", this.searchGlobal);
      }
      axios
        .post("/?m=BimModelsList&a=getModelsJson", data)
        .then(response => {
          this.loading = false;
          this.notFound = true;
          if (response.data.Result.Grid.totalItems !== 0) {
            //кол-во моделей
            this.totalmodels = response.data.Result.Grid.totalItems;
          } else {
            this.totalmodels = 0;
          }
          if (response.data.Result.Grid.totalPages !== 0) {
            if (response.data.Result.Grid.totalPages == 2) {
              //кол-во страниц
              this.totalmodelsPages = response.data.Result.Grid.totalPages;
            } else {
              this.totalmodelsPages = response.data.Result.Grid.totalPages;
            }
            if (this.totalmodelsPages < this.page) {
              this.changePage(this.totalmodelsPages);
              return;
            }
          } else {
            this.totalmodelsPages = 0;
          }
          if (!_.isEmpty(response.data.Result.Grid.data)) {
            if (val !== "add_30_models") {
              this.modelList = [];
            }
            this.modelList.push(...response.data.Result.Grid.data);
          } else {
            this.modelList = [];
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    /**
     * Получение статей для отрисовки
     */
    // getDataArticles() {
    //   const data = new URLSearchParams();
    //   this.articlesList = [];
    //   this.loading = true;
    //   axios
    //     .post("/?m=News&a=getAllNewsList", data)
    //     .then(response => {
    //       this.loading = false;
    //       if (!_.isEmpty(response.data.rows)) {
    //         response.data.rows.forEach(nod => {
    //           this.articlesList.push(nod);
    //           this.notFound = true;
    //         });
    //         this.articlesSort();
    //       } else {
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    // /**
    //  * Получение производителей для отрисовки
    //  */
    // getDataManufacturers() {
    //   const data = new URLSearchParams();
    //   this.sortByVip = [];
    //   this.loading = true;
    //   axios
    //     .get("/?m=Manufacturers&a=ManufacturersJson", data)
    //     .then(response => {
    //       this.loading = false;
    //       this.notFound = true;
    //       if (!_.isEmpty(response.data.data)) {
    //         response.data.data.forEach(nod => {
    //           this.sortByVip.push(nod);
    //         });
    //       } else {
    //       }
    //     })
    //     .catch(function(error) {
    //       console.log(error);
    //     });
    // },
    getRenderData(val) {
      this.loading = true;
      const dataModel = new URLSearchParams(),
        dataArticle = new URLSearchParams(),
        dataManufacturer = new URLSearchParams();

      // Модели
      let man = false;
      if (val === "add_30_models") {
        this.loading = true;
        if (this.page_models === this.totalpages) {
          this.modelList = [];
        } else {
          this.page_models = this.page_models + 1;
        }
      } else {
        if (!_.isEmpty(val)) {
          dataModel.append("manufacturer", val);
          man = true;
        }
      }
      dataModel.append("limit", 30);
      dataModel.append("sort", "random");

      if (this.page_models) {
        dataModel.append("page", this.page_models);
      }

      if (!man) {
        dataModel.append("name", this.searchGlobal);
      }

      // Статьи
      this.articlesList = [];

      // Производители
      this.sortByVip = [];

      // Запрос
      return Promise.all([
        axios.post("/?m=BimModelsList&a=getModelsJson", dataModel),
        axios.post("/?m=News&a=getAllNewsList", dataArticle),
        axios.post("/?m=Manufacturers&a=ManufacturersJson", dataManufacturer)
      ])
        .then(([models, articles, manufacturers]) => {
          // Модели
          if (models.data.Result.Grid.totalItems !== 0) {
            //кол-во моделей
            this.totalmodels = models.data.Result.Grid.totalItems;
            //кол-во страниц
            this.totalmodelsPages = models.data.Result.Grid.totalPages;
            if (this.totalmodelsPages < this.page) {
              this.changePage(this.totalmodelsPages);
              return;
            }
          } else {
            this.totalmodels = 0;
            this.totalmodelsPages = 0;
          }

          if (!_.isEmpty(models.data.Result.Grid.data)) {
            if (val !== "add_30_models") {
              this.modelList = [];
            }
            this.modelList.push(...models.data.Result.Grid.data);
          } else {
            this.modelList = [];
          }

          // Статьи
          // articles.data.rows.forEach(nod => {
          //   this.articlesList.push(nod);
          // });
          this.articlesList.push(...articles.data.rows);
          this.articlesSort();

          // Производители
          manufacturers.data.data.forEach(nod => {
            this.sortByVip.push(nod);
          });
          this.sortingVip();

          this.loading = false;
          this.notFound = true;
        })
        .catch(err => console.log(err));
    },
    /**
     * Получаем модели и производителей для выпадашки в поиске
     */
    getData () {
      axios
        .get('/?a=GetCatLists&key=ext')
        .then(response => {
          this.searchResult.push({
            id: 'search',
            type: 'search',
          })
          this.dropdownLists.models = response.data.class.map(model => ({
            code: model.code,
            name: model.name,
            meta_alias: model.meta_alias,
            type: "model"
          }))
          this.dropdownLists.manufacturers = response.data.organizations.map(org => ({
            id: org.id,
            name: org.name_full,
            meta_alias: org.name_short,
            count: org.count,
            type: "org"
          }))
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    /**
     * Отображение результатов
     */
    async enterListItem(idx) {
      if (idx === 0) this.highlightedIndex = 0;
      this.showPaginationModels = false;

      // let item = _.concat(this.$refs.findCategory, this.$refs.srch);
      // let item = this.$refs.findCategory;
      let item = document.querySelectorAll('.list_item');
      item.forEach((item, index) => {
        if (index === this.highlightedIndex && this.highlightedIndex !== 0) {
          window.open(item.firstChild.getAttribute("href"));
          // location.href = item.firstChild.getAttribute("href");
        }
      });
      // this.activeTab = 1;
      this.params.currentPage = 1;
      this.page_models = 1;
      // this.getDataParams();
      await this.getRenderData();
      this.showPaginationModels = true;
      // this.sortingVip();
      // this.getDataArticles();
      // this.getDataManufacturers();
      this.closed = true;
    },
    // showNotFound() {
    //   if(this.notFound === true && this.searchGlobal.length > 0 && this.filteredResult.length === 0 && this.articlesFiltredList.length === 0) {
    //     return true
    //   } else return false
    // },
    // getCompanyData(id) {
    //   this.params.currentPage = 1;
    //   this.getDataParams(id);
    //   this.getDataArticles();
    //   this.getDataManufacturers();
    //   // let item = _.concat(this.$refs.findCategory, this.$refs.srch);
    //   this.closed = true;
    //   // item.forEach((item, index) => {
    //   //     if (index == this.selectedEl) {
    //   //         location.href = item.firstChild.getAttribute("href");
    //   //         this.closed = true;
    //   //     }
    //   //     if (this.selectedEl == -1) {
    //   //         location.href = "/models?name=" + this.searchGlobal;
    //   //         this.closed = true;
    //   //     }
    //   // });
    // },

    /**
     * Сброс позиции выбора при вводе новых параметров поиска
     */
    // resetPositionSelect(e) {
    //   if (
    //     e.keyCode != 38 &&
    //     e.keyCode != 40 &&
    //     e.keyCode != 13 &&
    //     this.searchGlobal.length >= 2
    //   ) {
    //     this.closed = true;
    //     this.selectedEl = -1;
    //     this.perebor();
    //   }
    // },
    sliceText(value, symbol) {
      return _.truncate(value, { length: symbol, separator: "..." });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/mixins";
@import './src/front_white/sass/components/settings';

.not-found {
  margin-top: 11.2rem;
  .bg-trsp {
    &:hover {
      // background-color: transparent !important;
    }
  }
}
.search-tab_link {
  cursor: pointer;

  @media (max-width: width-max($breakpoint-xxl)) {
			@include font-main(14px, bold, 1.33, normal, $text-search);
		}

  @include font-main(1.2rem, bold, 1.33, normal, $text-search);

  &:hover {
    color: $text-second-dark;
  }
}
.search-tab_link--active {
  color: $active !important;
}
.search-tab_link--disabled {
  color: $text-search !important;
  cursor: not-allowed;
}
.search-wrapper {
  position: relative;

  padding-top: 5rem;
  // padding-bottom: 6.6667rem;
  // overflow: hidden;
}

.search-result_models {
  padding-bottom: 6.6667rem;
}

.icon_search {
  padding-right: 2.1333rem;

  color: $text-soft-dark;
}

.label-list {
  display: inline-flex;
  padding: 0rem 2.1333rem;

  font-weight: bold;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  // transform: translateX(0.625rem);
  opacity: 0;
}

.slideup-fade-enter-active {
  transition: all 0.3s ease;
}
.slideup-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slideup-fade-enter,
.slideup-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  // transform: translateY(-0.625rem);
  opacity: 0;
}
.tag-block {
  display: flex;
  align-items: center;
  height: 3.4rem;
  margin-right: 0.9333rem;
  margin-bottom: 0.9333rem;
  padding: 0.9333rem;

  background-color: $bg-search-tags;
  border-radius: 0.3333rem;
  &:hover {
    background-color: $bg-main;
  }
  &:active {
    background-color: $bg-soft-active;
  }
  img {
    display: inline-block;
    width: 2.3333rem;
    height: 2.3333rem;
    margin-right: 0.5333rem;
    margin-left: -0.4rem;

    border-radius: 0.3333rem;

    object-fit: cover;
  }
  .tag-text {
    font-size: 1.6rem;
    line-height: 1.5;
    letter-spacing: 0.0133rem;
  }
}

// Производители
.manufacturers {
  max-height: 9.5667rem;
  padding-top: 0.0667rem;
  overflow: hidden;
}
.manufacturer-card,
.manufacturer-card--vip {
  position: relative;

  flex-basis: 12.1333rem;
  max-width: 12.1333rem;
  height: 8.8667rem;
  padding: 1.2rem;
  overflow: hidden;

  background-color: $bg-main;
  border: solid 0.0667rem #ebebeb;
  border-radius: 0.3333rem;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    // transform: scale(0);
    opacity: 0;

    background-color: rgba(227, 232, 235, 0.6);
  }
  &:hover {
    &:after {
      // transform: scale(1);
      opacity: 1;
    }
  }
  &:active {
    &:after {
      background-color: rgba(227, 232, 235, 0.85);
    }
  }
}
.manufacturer-card--vip {
  border: solid 0.0667rem rgba($extra-active, 0.25);
}
.manufacturer-name {
  font-size: 0.9333rem;
}

.manufacturer-logo {
  width: 4.4rem;
  min-width: 4.4rem;
  height: 4.4rem;
  margin: 0.8667rem;

  object-fit: contain;
  img {
    height: 4.4rem;

    object-fit: contain;
  }
}
.models-counter {
  display: flex;
  align-items: center;

  @include font-main(0.8667rem, 600, 1.77, 0.0667rem, $text-search);
}
.icon-vip,
.icon-medal {
  display: flex;
  align-items: center;
  margin-right: 0.4667rem;
}
.icon-vip {
  font-size: 0.6rem;
}
.icon-mark-models {
  margin-right: 0.3334rem;
}

// Новости
.news {
  max-height: 18.8rem;
  overflow: hidden;
  &-card {
    position: relative;

    width: 12.1333rem;
    max-width: 12.1333rem;
    height: 18rem;
    max-height: 18rem;
    overflow: hidden;

    border: solid 0.0667rem $text-soft-light;
    border-radius: 0.3333rem;
    // &:before{
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   width: 100%;
    //   height: 9.9333rem;
    //   background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
    //   z-index: 1;
    // }
    // &:after{
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    //   width: 100%;
    //   height: 4.6rem;
    //   background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75) 42%, #000000);
    //   z-index: 2;
    // }
    &:hover {
      &::before {
        height: 100%;
      }
      .news_img {
        top: -148px;
      }
      .news_block {
        top: 0 !important;
      }
      .news_counter-block {
        left: 20px;

        opacity: 0;
      }
      .news_read-more {
        left: 0.6667rem;

        opacity: 1;
      }
    }
    &:active {
      .news_read-more {
        opacity: 0.4;
      }
    }
  }
  &_img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    width: 100%;
    height: 9.8rem;

    object-fit: cover;
  }
  .no-image {
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: $bg-search-noImg;
  }
  &_block {
    position: absolute;
    top: 9.7333rem;
    left: 0;
    z-index: 2;

    padding: 0.8667rem 0.6667rem 2.5333rem;

    background-color: $bg-main;
  }
  &_header {
    margin-bottom: 0.6333rem;

    @include font-main(0.8667rem, bold, 1.38, 0.0133rem, $text-main);
  }
  &_text {
    @include font-main(0.8667rem, normal, 1.54, 0.02rem, $text-second);
  }
  &_footer {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 4;

    width: 100%;
    height: 2.8rem;

    background-color: $bg-main;
    box-shadow: 0 -20px 20px 0 $bg-main;
  }
  &_counter-block,
  &_read-more {
    position: absolute;
    bottom: 0.7333rem;
    left: 0.6667rem;
    z-index: 4;
  }
  &_counter-block {
    opacity: 1;

    @include font-main(0.8667rem, 600, 1.77, 0.0667rem, $text-search);
    -webkit-text-fill-color: $text-search;

    span:first-of-type {
      margin-right: 0.6667rem;
    }
    i {
      margin-right: 0.3333rem;

      font-size: 1rem;
    }
    .icon-mark-comments {
      font-size: 0.87rem;
    }
  }
  &_read-more {
    bottom: 0.8667rem;
    left: -20px;

    opacity: 0;

    @include font-main(0.6rem, 600, 2, 0.0667rem, $text-main);
  }
}
.activeInf {
  color: $active;

  fill: $active;
  -webkit-text-fill-color: $active;
}
</style>
